import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("i", {
    class: _normalizeClass(["sv-font-icon", _ctx.classType]),
    style: _normalizeStyle([_ctx.baseStyles, _ctx.gradationStyle])
  }, null, 6))
}